import React, { Fragment, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types'
import Input from '../../1_Atoms/Forms/Input/Input';
import Button from '../../1_Atoms/Button/Button';
import FormGroup from '../../2_Molecules/FormGroup/FormGroup';
import { getEndpointUrl } from '../../../utils/endPoints';
import Form from '../../2_Molecules/Form/Form';
import { languageController } from '../../../controllers/language/languageController';
import { useForm } from '../../../hooks/useForm';
import FormContainer from '../../2_Molecules/FormContainer/FormContainer';
import FormConfirmation from '../../2_Molecules/FormConfirmation/FormConfirmation';
import Checkbox from '../../1_Atoms/Forms/Checkbox/Checkbox';
import parse from 'html-react-parser';
import Modal from '../../2_Molecules/Modal/Modal';
import { closeModal } from '../../../utils/helpers';
import { handleAnalyticsTrackingCodes, pushToGTMDataLayer } from '../../../utils/helpers';
import axios from 'axios';

function ShareBuildModal({ formExtraParams }) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formError, setFormError] = useState(null);
  const modalRef = useRef(null);

  const { language, formDisclaimer } = formExtraParams

  const initState = {
    firstname: '',
    lastname: '',
    email: '',
    buildname: '',
    recipientName: '',
    recipientEmail: '',
    //optin: false,
    build: {}
  }

  const validations = {
    firstname: ['required', 'name', 'nameMaxMin'],
    lastname: ['required', 'name', 'nameMaxMin'],
    email: ['required', 'email'],
    buildname: ['required'],
    recipientName: ['required', 'name'],
    recipientEmail: ['required', 'email'],
  }

  const { handleSubmit, handleChange, data, errors, setData } = useForm({
    initState,
    validations,
    // Send the form data if validated
    onSubmit: async () => {
      try {
        let reqData = {
          first_name: data.firstname,
          last_name: data.lastname,
          email: data.email,
          recipient_name: data.recipientName,
          recipient_email: data.recipientEmail,
          build_name: data.buildname,
          //optin: data.optin ? 'on' : 'off',
          //build: data.build,
          lang_code: language
        }
		reqData = getBuildData(reqData);

        const params = new URLSearchParams(reqData);
        const res = await axios.post(getEndpointUrl('share-build'), params);
        const resData = res.data;

        if (resData && resData.status === 200) {
          setIsSubmitted(true);
          pushToGTMDataLayer({ formevent: 'submit'});
          handleAnalyticsTrackingCodes(data, 'Form Submit', 'Share Build Modal', 'ShareBuildModal');
          setData(initState)
        } else {
          setFormError(resData.msg);
        }
      } catch (err) {
        console.log(err)
      }
    },
  })
  
  // Set the build data using data in sessionStorage.
 const getBuildData = (newData) => {
	 const selectedTrim = sessionStorage.getItem("selectedTrim");
	 const selectedVehicle = sessionStorage.getItem("SelectedVehicle");
	 const financialObj = sessionStorage.getItem("financialObj");
	 const selectedAccessories = sessionStorage.getItem("selectedAccessories");
	 const selectedWheelIndex = sessionStorage.getItem("SelectedWheelIndex");
	 const selectedColourExteriorIndex = sessionStorage.getItem("SelectedColourExteriorIndex");
	 const selectedColourInteriorIndex = sessionStorage.getItem("SelectedColourInteriorIndex");
	 const selectedNonModelPackageIndex = sessionStorage.getItem("selectedNonModelPackageIndex");
	 const includeTaxes = sessionStorage.getItem("includeTaxes");
	 const includeFees = sessionStorage.getItem("includeFees");
	 const includeRebates = sessionStorage.getItem("includeRebates");
	 const annualMileage = sessionStorage.getItem("AnnualMileage");
   const province = sessionStorage.getItem("province");
   const selectedConnectedVehicleIndex = JSON.parse(sessionStorage.getItem("selectedConnectedVehicleIndex"));
   const selectedAddedProtectionIndex = JSON.parse(sessionStorage.getItem("selectedAddedProtectionIndex"));
   const selectedAppearanceProtectionIndex = JSON.parse(sessionStorage.getItem("selectedAppearanceProtectionIndex"));
   const selectedAppearanceProtectionPlanPackageIndex = JSON.parse(sessionStorage.getItem("selectedAppearanceProtectionPlanPackageIndex"));

	 if (selectedTrim) {
	   const selectedTrimParsed = JSON.parse(selectedTrim);
	   newData.buildname = selectedTrimParsed.title ? selectedTrimParsed.title : '';
	 }

	 if (financialObj) {
	   const financialObjParsed = JSON.parse(financialObj);
	   const buildData = {
      modelCode: financialObjParsed.based_on?.model_code,
      optionCode: financialObjParsed.based_on?.option_code,

      tradeInValue: financialObjParsed.tradeInValue,
      downPaymentValue: financialObjParsed.downPaymentValue,
      loyaltyChecked: financialObjParsed.loyaltyChecked,
      militaryChecked: financialObjParsed.militaryChecked,
      graduateChecked: financialObjParsed.graduateChecked,

      financeTerm: financialObjParsed.financeTerm,
      leaseTerm: financialObjParsed.leaseTerm,
	   };

	   // Add selected accessories (part number as an array)
	   if (selectedAccessories) {
      const selectedAccessoriesParsed = JSON.parse(selectedAccessories);

      if (selectedAccessoriesParsed.length > 0) {
        buildData.accessories = selectedAccessoriesParsed.map(acc => acc.part_number);
      }
	   }

	   if(selectedWheelIndex) buildData.SelectedWheelIndex = selectedWheelIndex;
	   if(selectedColourExteriorIndex) buildData.SelectedColourExteriorIndex = selectedColourExteriorIndex;
	   if(selectedColourInteriorIndex) buildData.SelectedColourInteriorIndex = selectedColourInteriorIndex;
	   if(selectedNonModelPackageIndex) buildData.selectedNonModelPackageIndex = selectedNonModelPackageIndex;
	   if(includeTaxes) buildData.includeTaxes = includeTaxes;
	   if(includeFees) buildData.includeFees = includeFees;
	   if(includeRebates) buildData.includeRebates = includeRebates;
	   if(annualMileage) buildData.annualMileage = annualMileage;
     if(province) buildData.province = province;
     
     if (selectedConnectedVehicleIndex !== null) buildData.selectedConnectedVehicleIndex = selectedConnectedVehicleIndex;
     if (selectedAddedProtectionIndex !== null) buildData.selectedAddedProtectionIndex = selectedAddedProtectionIndex;
     if (selectedAppearanceProtectionIndex && selectedAppearanceProtectionPlanPackageIndex) {
       buildData.selectedAppearanceProtectionIndex = selectedAppearanceProtectionIndex;
       buildData.selectedAppearanceProtectionPlanPackageIndex = selectedAppearanceProtectionPlanPackageIndex;
     }

	   // Add selected vehicle data.
	   if (selectedVehicle) {
      const selectedVehicleParsed = JSON.parse(selectedVehicle);
      buildData.year = selectedVehicleParsed.year;
      buildData.carline = selectedVehicleParsed.carline;
      buildData.trim = selectedVehicleParsed.trim;
	   }

	   newData['build']  = JSON.stringify(buildData);
	 }

	 return newData;
  }

  const { firstname, lastname, email, buildname, /*optin,*/ recipientName, recipientEmail } = data;

  return (
    <Modal
      className="mz-share-build-modal mz-modal-form"
      id="mz-react-share-build-modal"
      onClose={() => setIsSubmitted(false)}
      modalRef={modalRef}
    >
      <FormContainer
        className="mz-share-build"
        isSubmitted={isSubmitted}
        heading={(
          <Fragment>
            <h3>{languageController.getCopy('shareBuild', 'heading')}</h3>
            <p>{languageController.getCopy('shareBuild', 'subHeading')}</p>
          </Fragment>
        )}
        confirmation={(
          <FormConfirmation
            heading={languageController.getCopy('shareBuild', 'confirmationHeading')}
            subHeading={languageController.getCopy('shareBuild', 'confirmationSubHeading')}
            buttonLabel={languageController.getCopy('shareBuild', 'confirmationSubmit')}
            onClick={() => {
              closeModal(modalRef.current);
              setIsSubmitted(false);
            }}
          />
        )}
      >
        <Form
          onSubmit={handleSubmit}
          isDark={false}
          noValidate={true}
          errorMessage={formError}
        >
          <FormGroup md={2}>
            <Input
              type="text"
              name="firstname"
              label={languageController.getFormCopy('label', 'firstname')}
              value={firstname}
              isRequired={true}
              errorMessage={errors.firstname}
              onChange={handleChange}
              maxLength={50}
            />
            <Input
              type="text"
              name="lastname"
              label={languageController.getFormCopy('label', 'lastname')}
              value={lastname}
              isRequired={true}
              errorMessage={errors.lastname}
              onChange={handleChange}
              maxLength={50}
            />
          </FormGroup>
          <Input
            type="email"
            name="email"
            label={languageController.getFormCopy('label', 'email')}
            value={email}
            isRequired={true}
            errorMessage={errors.email}
            onChange={handleChange}
            maxLength={320}
          />
          <Input
            type="text"
            name="buildname"
            label={languageController.getFormCopy('label', 'buildName')}
            value={buildname}
            isRequired={true}
            errorMessage={errors.buildname}
            onChange={handleChange}
            maxLength={100}
          />
          <FormGroup md={2}>
            <Input
              type="text"
              name="recipientName"
              label={languageController.getFormCopy('label', 'recipientName')}
              value={recipientName}
              isRequired={true}
              errorMessage={errors.recipientName}
              onChange={handleChange}
              maxLength={50}
            />
          </FormGroup>
          <Input
            type="email"
            name="recipientEmail"
            label={languageController.getFormCopy('label', 'recipientEmail')}
            value={recipientEmail}
            isRequired={true}
            errorMessage={errors.recipientEmail}
            onChange={handleChange}
            maxLength={320}
          />
          <Button
            type="submit"
            className="mz-btn--primary mz-btn--red"
            label={languageController.getCopy('shareBuild', 'submit')}
          />
        </Form>
      </FormContainer>
    </Modal>
  )
}

ShareBuildModal.propTypes = {
  formExtraParams: PropTypes.object
}

export default ShareBuildModal